var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loadData
    ? _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "div",
            [
              _c(
                "v-container",
                [
                  _c(
                    "h3",
                    { staticStyle: { "text-align": "left", color: "#1976d2" } },
                    [_vm._v("Service Information")]
                  ),
                  _vm._v(" "),
                  _c("service-information", {
                    attrs: {
                      v: _vm.$v.student.form.serviceInformation,
                      needLevelArray: _vm.needLevelArray,
                      deliveryModeArray: _vm.deliveryModeArray,
                      student: _vm.student,
                      showTooltip: _vm.showTooltip,
                      "supervisor-flags-array": _vm.supervisorFlagsArray,
                      action: _vm.action
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.student.form.serviceInformation &&
              _vm.student.form.serviceInformation.needLevel !==
                _vm.constants.ABSENT
                ? [
                    _c(
                      "v-container",
                      { attrs: { "py-0": "" } },
                      [
                        _c(
                          "v-layout",
                          {
                            class: {
                              "pa-1 pr-3": _vm.isMobile,
                              "pa-2": !_vm.isMobile
                            },
                            attrs: { row: "", wrap: "" }
                          },
                          [
                            _c("v-flex", { attrs: { xs8: "", "pt-1": "" } }, [
                              _c(
                                "h3",
                                {
                                  staticStyle: {
                                    "text-align": "left",
                                    color: "#1976d2"
                                  }
                                },
                                [_vm._v("Documentation Of Service")]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { xs4: "" } },
                              [
                                _c(
                                  "v-text-field",
                                  {
                                    staticClass: "mt-0 pt-0",
                                    attrs: {
                                      disabled: "",
                                      "error-messages":
                                        _vm.totalReimbursableMinutesErrors
                                    },
                                    model: {
                                      value:
                                        _vm.student.form
                                          .totalReimbursableMinutes,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.student.form,
                                          "totalReimbursableMinutes",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "student.form.totalReimbursableMinutes"
                                    }
                                  },
                                  [
                                    _c("template", { slot: "label" }, [
                                      _vm.isMobile
                                        ? _c("span", [
                                            _c("small", [
                                              _vm._v("Tot Reimb Mins")
                                            ])
                                          ])
                                        : _c("span", [
                                            _vm._v("Total Reimbursable Minutes")
                                          ])
                                    ])
                                  ],
                                  2
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("medicaid-information", {
                          attrs: {
                            v: _vm.$v.student.form.medicaid,
                            student: _vm.student,
                            medicaidArray: _vm.medicaidArray,
                            showTooltip: _vm.showTooltip
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              [
                _c(
                  "v-container",
                  [
                    _c(
                      "h3",
                      {
                        staticStyle: { "text-align": "left", color: "#1976d2" }
                      },
                      [_vm._v("Notes")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-container",
                      [
                        _c("v-textarea", {
                          attrs: {
                            name: "description",
                            box: "",
                            label: "Notes",
                            autoGrow: ""
                          },
                          model: {
                            value: _vm.student.form.notes,
                            callback: function($$v) {
                              _vm.$set(_vm.student.form, "notes", $$v)
                            },
                            expression: "student.form.notes"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  class: { "py-1": _vm.isMobile, "pt-3": !_vm.isMobile },
                  attrs: { row: "", wrap: "" }
                },
                [
                  _c("extended-service-information", {
                    ref: "extendedServiceInformation",
                    attrs: {
                      action: _vm.action,
                      student: _vm.student,
                      supervisorFlagsArray: _vm.supervisorFlagsArray,
                      v: _vm.$v.student.form.serviceInformation,
                      signature: ""
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-container",
                { staticClass: "mb-5" },
                [
                  _c(
                    "v-radio-group",
                    {
                      attrs: { column: "" },
                      model: {
                        value: _vm.saveOptions,
                        callback: function($$v) {
                          _vm.saveOptions = $$v
                        },
                        expression: "saveOptions"
                      }
                    },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { disabled: !_vm.showTooltip, top: "" } },
                        [
                          _vm.index < _vm.arrayLength - 1
                            ? _c("v-radio", {
                                attrs: {
                                  slot: "activator",
                                  label: "Save & Next Student",
                                  value: "next",
                                  color: "primary"
                                },
                                slot: "activator"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Save and go to next student")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        { attrs: { disabled: !_vm.showTooltip, top: "" } },
                        [
                          _vm.arrayLength === 1 ||
                          _vm.index === _vm.arrayLength - 1
                            ? _c("v-radio", {
                                attrs: {
                                  slot: "activator",
                                  label: "Save",
                                  value: "save",
                                  color: "primary"
                                },
                                slot: "activator"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Save log")])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        { attrs: { disabled: !_vm.showTooltip, top: "" } },
                        [
                          _vm.arrayLength === 1 && _vm.action !== "edit"
                            ? _c("v-radio", {
                                attrs: {
                                  slot: "activator",
                                  label: "Save & Clone",
                                  value: "copy",
                                  color: "primary"
                                },
                                slot: "activator"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v("Save log and create duplicate")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-alert",
                    { attrs: { value: _vm.errorMsg, type: "error" } },
                    [_vm._v("\n        " + _vm._s(_vm.errorMsg) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          class: { block: _vm.isMobile },
                          on: { click: _vm.onCancelButtonClicked }
                        },
                        [_vm._v("\n          Cancel\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        { attrs: { disabled: !_vm.showTooltip, top: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              class: { block: _vm.isMobile },
                              attrs: {
                                slot: "activator",
                                disabled: !_vm.saveOptions
                              },
                              on: {
                                click: function($event) {
                                  return _vm.submit(_vm.student)
                                }
                              },
                              slot: "activator"
                            },
                            [_vm._v("\n            Submit\n          ")]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Submit saved log")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-snackbar",
                    {
                      attrs: { timeout: _vm.timeout, color: "cyan darken-2" },
                      model: {
                        value: _vm.toaster,
                        callback: function($$v) {
                          _vm.toaster = $$v
                        },
                        expression: "toaster"
                      }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.toasterMsg) + "\n      ")]
                  )
                ],
                1
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("bottom-nav"),
          _vm._v(" "),
          _vm.showLoading ? _c("div", [_c("loading-component")], 1) : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ccf27d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ccf27d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-log/form/service-log-form/service-log-form.vue
// module id = null
// module chunks = 